<div [hidden]="options.length===0 || !open || !editable" class="options" [ngClass]="{'dropup':dropUp}">
  <div *ngFor="let o of options; index as index" class="form-check">
    <input tabindex="-1" id="{{id+'-'+o.key}}" [checked]="o.selected" type="checkbox"
      class="form-check-input" [disabled]="o.disabled"
      (change)="toggleOption(index)" (click)="$event.stopPropagation()">
    <label for="{{id+'-'+o.key}}" class="form-check-label"
      (click)="toggleOption(index); $event.stopPropagation(); $event.preventDefault()">
      &nbsp;{{o.value}}
    </label>
  </div>
</div>
